import React, { useState } from 'react'
import PropTypes from 'prop-types'
import AsyncSelect from 'react-select/async'
import School from '../../../models/School'
import District from '../../../models/District'
import Select from "react-select";
import axios from "axios";
import { Padding } from '@mui/icons-material'

const SchoolAsyncSelect = ({ name, jotformUrl, cartId }) => {
  const [school, setSchool] = useState()
  const [district, setDistrict] = useState()
  const [schoolEmployee, setSchoolEmployee] = React.useState("");

  const changeHandler = (opt) => {
    setSchool(opt)
  }

  const changeDistrictHandler = (opt) => {
    setDistrict(opt)
    setSchool()
  }

  const changeSchoolEmployee = (opt) => {
    setSchoolEmployee(opt)
  }

  const options = [
    { value: "None", label: "None" },
    { value: "Principal", label: "Principal" },
    { value: "Vice-Principal", label: "Vice-Principal" },
    { value: "Office Manager", label: "Office Manager" },
    { value: "Secretary", label: "Secretary" },
    { value: "Teacher", label: "Teacher" },
    { value: "Educational Support", label: "Educational Support" }
  ];

  const handleClick = (e) => {
    e.preventDefault();


    axios.post(jotformUrl, {cart: {school_id: school.value, school_employee: schoolEmployee.value}})
      .then((res) => {
        console.log(res.data.status)
        console.log("Success!")
        window.location = `/items/${cartId}/orders/new`
      })
  }

  const formatUrl = () => {
    if (!school) return '';
    const url = new URL(jotformUrl);

    url.searchParams.append('school_id', school.value);
    url.searchParams.append('school_employee', schoolEmployee.value);

    return url
  }

  const loadSchoolOptionsQuery = () => (value, callback) => {
    School
      .where({
        district_id: district.data.id,
        name: { match: value },
      })
      .order({ name: 'asc' })
      .per(50)
      .all()
      .then((res) => {
        const options = res.data.map((e) => ({ label: e.cityName ? `${e.name} (${e.cityName})` : e.name, value: e.id, data: e }))
        callback(options)
      })
  }

  const loadDistrictOptionsQuery = () => (value, callback) => {
    District
      .where({
        name: { match: value }
      })
      .order({ name: 'asc' })
      .per(50)
      .all()
      .then((res) => {
        const options = res.data.map((e) => ({ label: e.name, value: e.id, data: e }))
        callback(options)
      })
  }

  return (
    <>
      <AsyncSelect
        cacheOptions
        defaultOptions
        placeholder="Select Your School District"
        defaultValue={district}
        name="district"
        loadOptions={loadDistrictOptionsQuery()}
        onChange={changeDistrictHandler}
      />

      <br/>

      {district && (
        <AsyncSelect
          cacheOptions
          defaultOptions
          placeholder="Select Your School"
          defaultValue={school}
          name={name}
          key={district.value}
          loadOptions={loadSchoolOptionsQuery()}
          onChange={changeHandler}
        />

      )}
      <br/>
       {school && (
        <Select
          options={options}
          onChange={(e) => changeSchoolEmployee(e)}
          value={schoolEmployee}
          label="Single select"
          placeholder={"Select Your Position"}
          menuPlacement="top"
          required
        />
        )}


      <br/>

      {schoolEmployee && school && (
        <div className='text-center' style={{ padding: "10px 35px" }}>
          <a href="#"
            onClick={handleClick} className="btn btn-primary btn-lg">
            Continue
          </a>
        </div>
      )}
    </>
  )
}

SchoolAsyncSelect.propTypes = {
  name: PropTypes.string,
  selectedValue: PropTypes.object,
  valueField: PropTypes.string,
  extraFields: PropTypes.array
}

SchoolAsyncSelect.defaultProps = {
  name: null,
  selectedValue: null,
  valueField: 'name',
  extraFields: []
}

export default SchoolAsyncSelect
